<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <div class="mt-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3
              class="text-3xl font-semibold tracking-wider font-open-sans leading-6 text-white"
            >
              Project Details
            </h3>
            <p class="mt-1 text-lg leading-5 font-semibold text-vectric">
              About Your Project
            </p>
          </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
          <Card class="px-6 py-5">
            <form action="#" method="POST" @submit.prevent="onFormSubmit">
              <div class="">
                <div
                  class="mt-6 bg-red-50 border-red-200 border text-red-700 p-2 rounded"
                  v-if="networkError"
                >
                  {{ networkError }}
                </div>
                <div
                  class="mt-6  rounded p-2 border border-red text-red"
                  v-if="validationErrors.length > 0"
                >
                  The form could not be submitted for the following reasons:
                  <ul class="list-disc ml-8">
                    <li v-for="(err, idx) in validationErrors" :key="idx">
                      {{ err }}
                    </li>
                  </ul>
                </div>

                <div class="mt-6">
                  <Label>
                    Your Name
                  </Label>
                  <input
                    id="yourName"
                    v-model="form.yourName"
                    class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  />
                </div>
                <div class="mt-6">
                  <Label>
                    Project Title
                  </Label>
                  <input
                    id="projectTitle"
                    v-model="form.projectTitle"
                    class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  />
                </div>
                <div class="mt-6">
                  <Label for="compatibility">
                    Youtube Link
                  </Label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <span
                      class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-vectric text-black text-sm"
                    >
                      https://youtu.be/
                    </span>
                    <input
                      id="youtube"
                      v-model="form.youtube"
                      class="form-input flex-1 block w-full rounded-none rounded-r-md transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="dQw4w9WgXcQ"
                    />
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Compatibility
                  </Label>
                  <div>
                    <v-select
                      id="compatibility"
                      :options="options"
                      v-model="form.compatibility"
                      placeholder="Which product was this made with?"
                    >
                    </v-select>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Project Description
                  </Label>
                  <p class="mt text-md text-gray-700">
                    Tell us about your project
                  </p>
                  <div class="rounded-md shadow-sm">
                    <textarea
                      id="description"
                      rows="3"
                      v-model="form.projectDescription"
                      class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="My project is..."
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Inspiration &amp; Motivation
                  </Label>
                  <p class="mt text-md text-gray-700">
                    What inspired you to make it?
                  </p>
                  <div class="rounded-md shadow-sm">
                    <textarea
                      id="inspiration"
                      rows="3"
                      v-model="form.inspiration"
                      class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="Recently I've been working on ..."
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Project Dimensions
                  </Label>
                  <p class="mt text-md text-gray-700">
                    Tell us how big your project is
                  </p>
                  <div class="rounded-md shadow-sm">
                    <textarea
                      id="projectSize"
                      rows="3"
                      v-model="form.projectSize"
                      class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="The total size is..."
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Materials Used
                  </Label>
                  <p class="mt text-md text-gray-700">
                    Tell us about the materials you used. Were they chosen for
                    specific reasons?
                  </p>
                  <div class="rounded-md shadow-sm">
                    <textarea
                      id="materialsUsed"
                      rows="3"
                      v-model="form.materialsUsed"
                      class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="I would have loved to have used some exotic woods, unfortunately all of the trees near me
are made of MDF"
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Tools & Finishes
                  </Label>
                  <p class="mt text-md text-gray-700"></p>
                  What tools and finishes did you you use? How long did this
                  part of the project take?
                  <div class="rounded-md shadow-sm">
                    <textarea
                      id="finishes"
                      rows="3"
                      v-model="form.finishes"
                      class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="Lots of sandpaper!"
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Hindsight
                  </Label>
                  <p class="mt text-md text-gray-700">
                    If you were making the same project again is there anything
                    you would do differently?
                  </p>
                  <div class="rounded-md shadow-sm">
                    <textarea
                      id="hindsight"
                      rows="3"
                      v-model="form.hindsight"
                      class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      placeholder="If I were doing this again I would have ..."
                    ></textarea>
                  </div>
                </div>

                <div class="mt-6">
                  <Label>
                    Photos
                  </Label>
                  <label
                    id="fileUpload"
                    @drop.stop.prevent="drop"
                    @dragover.prevent.stop
                    @dragenter.prevent.stop
                    class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-vectric border-dashed rounded-md cursor-pointer"
                  >
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      for="fileUpload"
                      @change="fileChanged"
                      style="display: none"
                    />
                    <div class="text-center">
                      <svg
                        class="mx-auto h-12 w-12 text-vectric"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <p class="mt-1 text-sm text-gray-600">
                        Upload a file or drag and drop
                      </p>
                      <p class="mt-1 text-xs text-gray-500">
                        PNG, JPG, GIF up to 10MB
                      </p>
                    </div>
                  </label>

                  <div v-if="formatError" class="text-mustard">
                    Please add only the following format: PNG, JPG, GIF
                  </div>

                  <div class="mt-4" v-if="uploading.length > 0">
                    <label>
                      Uploading
                    </label>
                    <div
                      class="p-2  border border-gray-300 rounded-lg my-2 text-vectric"
                      v-for="upload in uploading"
                      :key="upload.key"
                    >
                      <span>{{ upload.name }}</span> -
                      <span> {{ Math.round(upload.progress) }}% </span>
                    </div>
                  </div>
                  <!--                  Complete Files -->
                  <div
                    class="flex flex-row items-center mt-4 flex-wrap"
                    v-if="complete.length > 0"
                  >
                    <div
                      v-for="file in complete"
                      :key="file.key"
                      class="flex flex-col items-center mx-2 mb-4"
                    >
                      <img
                        :src="file.url"
                        class="w-24 h-24 object-cover border border-gray-200"
                      />
                      <button
                        class="text-xs text-red"
                        @click="() => removeComplete(file.key)"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>

                <fieldset class="mt-6">
                  <legend class="block ">
                    <Label>
                      Sharing
                    </Label>
                  </legend>
                  <div class="mt-4">
                    <div class="relative flex items-start">
                      <div class="flex items-center h-5">
                        <input
                          id="sharing"
                          type="checkbox"
                          class="form-checkbox h-4 w-4 text-darkgreen transition duration-150 ease-in-out"
                          v-model="form.allowMarketing"
                        />
                      </div>
                      <div class="ml-3  leading-5">
                        <label for="sharing" class="text-md text-gray-800"
                          >I'm happy for Vectric to use my project for marketing
                          purposes</label
                        >
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="px-4 py-3  bg-white text-right sm:px-6">
                <div
                  class="my-6  rounded p-2 border border-red text-red text-left"
                  v-if="validationErrors.length > 0"
                >
                  The form could not be submitted for the following reasons:
                  <ul class="list-disc ml-8">
                    <li v-for="(err, idx) in validationErrors" :key="idx">
                      {{ err }}
                    </li>
                  </ul>
                </div>
                <span class="inline-flex rounded-md shadow-sm" v-else>
                  <button
                    type="submit"
                    class="raleway-btn bg-vectric text-black hover:bg-darkBlue hover:text-white flex items-center space-x-2"
                  >
                    <span>
                      {{ submitted ? "Sharing" : "Share" }}
                    </span>
                    <LoaderIcon
                      v-if="submitted"
                      class="text-black w-6 h-6 fill-current"
                    ></LoaderIcon>
                  </button>
                </span>
              </div>
            </form>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import {shareProject} from "../utils/functions";
import {createUniqueFileName} from "../utils/fileUtils";
import {auth, storageService} from "../utils/firebase";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import Label from "../components/shared/Label.vue";
import Card from "../components/shared/Card.vue";
import LoaderIcon from "../components/shared/LoaderIcon.vue";

export default {
  name: "Share",
  components: {
    LoaderIcon,
    Card,
    Label,
     vSelect
  },
  data() {
    return {
      submitted: false,
      droppedFiles: [],
      files: {},
      networkError: null,
      validationErrors: [],
      form: {
        yourName: "",
        projectTitle: "",
        projectDescription: "",
        youtube: "",
        compatibility: "",
        inspiration: "",
        projectSize: "",
        materialsUsed: "",
        finishes: "",
        hindsight: "",
        images: "",
        allowMarketing: false,
        projectPhotos: []
      },
      options: [
        'Aspire',
        'VCarve Pro',
        'VCarve Desktop',
        'Cut2D Desktop',
        'Cut2D Pro',
      ],
      formatError: false
    }
  },
  computed: {
    uploading() {
      const files = this.files
      return Object.keys(files)
        .filter(key => files[key].state === "UPLOADING")
        .map(key => files[key]);
    },
    complete() {
      const files = this.files
      return Object.keys(files)
        .filter(key => files[key].state === "COMPLETE")
        .map(key => files[key]);
    }
  },
  mounted() {
    if (auth.currentUser) {
      this.form.yourName = auth.currentUser.displayName;
    }
  },
  methods: {
    setProgress(key, progress, name) {
      this.$set(
        this.files,
        key,
        {
          key: key,
          state: "UPLOADING",
          progress: progress,
          name: name
        }
      )
    },
    setComplete(key, url) {
      this.$set(
        this.files,
        key,
        {
          key: key,
          state: "COMPLETE",
          url: url
        }
      )
    },
    drop(e) {
      const self = this;
      self.formatError = false;
      const droppedFiles = e.dataTransfer.files;
      ([...droppedFiles]).forEach(f => {
        if (f.type.startsWith("image/")) {
          self.uploadFile(f)
        }else{
          self.formatError = true;
        }
      });
    },
    // Called when a file has changed
    fileChanged(e) {
      const self = this;
      self.formatError = false;
      const files = e.target.files;
      ([...files]).forEach(function (f) {
        if (f.type.startsWith("image/")) {
          self.uploadFile(f)
        }else{
          self.formatError = true;
        }
      })
    },
    validateForm() {
      const validationErrors = [];
      if (this.form.yourName.length === 0) {
        validationErrors.push("Please add your name");
      }
      if (this.form.projectTitle.length === 0) {
        validationErrors.push("Please add a title");
      }

      const files = this.files;
      const complete  = Object.keys(files)
        .filter(key => files[key].state === "COMPLETE")
        .map(key => files[key]);

      if (complete.length === 0) {
        validationErrors.push("Please upload at least one photo");
      }

       const uploading  = Object.keys(files)
        .filter(key => files[key].state === "UPLOADING")
        .map(key => files[key]);
       if (uploading.length > 0) {
         validationErrors.push("Pleas wait for uploads to finish before uploading")
       }

      return validationErrors;
    },
    // Called on forum submission
    onFormSubmit() {
      this.submitted = true;
      const self = this;
      this.validationErrors = []
      const errors = this.validateForm();
      if (errors.length > 0) {
        // Some point we should set some errors
        this.validationErrors = errors;
        this.submitted = false;
        return;
      }
      // Now we want to put the projectPhotos in
      const photos = this.complete.map(f => f.url);
      this.$set(this.form, 'projectPhotos', photos);
      this.submitted = true
      shareProject(self.form)
        .then(
          function () {
            // Set something in the store
            self.$store.dispatch('setFlashMessage', "Thanks for sharing! We're just taking a minute to approve this");
            // redirect
            self.$router.push("userProjects");
          }
        )
        .catch(err => {
          console.log(err);
          self.networkError = err;
          self.submitted = false
        });
    },
    // Does the file uploading
    uploadFile(file) {
      const self = this;
      console.log(file);
      let uniqueFileName = createUniqueFileName(file);
      const uploadTask = storageService.ref(`/images/${uniqueFileName}`).put(file);

      uploadTask.on(
        "state_changed",
        function (snapshot) {
          // on Progress
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          self.setProgress(snapshot.ref.fullPath, progress, snapshot.ref.name)
        },
        function (error) {
          self.networkError = error
        },
        function () {
          // on Complete
          uploadTask.snapshot.ref.getDownloadURL().then(function (url) {
            self.setComplete(uploadTask.snapshot.ref.fullPath, url)
          });
        }
      );
    },
    // Remove a  complete file
    removeComplete(key) {
      this.$delete(this.files, key)
    }
  }


}
</script>
